<template>
  <GrayBlockContainer class="w-[560px]">
    <div>
      <ToggleGroup bold :groupName="displayText.orderInfo.groupName" :switchName="displayText.orderInfo.switchName" :options.sync="orderInfo" />
      <ToggleGroup bold :groupName="displayText.detailInfo.groupName" :switchName="displayText.detailInfo.switchName" :options.sync="detailInfo" />
      <ToggleGroup v-if="showControl.otherInfo" bold :groupName="displayText.otherInfo.groupName" :switchName="displayText.otherInfo.switchName" :options.sync="otherInfo" />
      <ToggleGroup v-if="showControl.userInfoSettingFormData" bold :groupName="displayText.userInfoSettingFormData.groupName" :switchName="displayText.userInfoSettingFormData.switchName" :options.sync="userInfoSettingFormData" />
      <!-- 會員預約備註 -->
      <header class="flex items-center justify-between mb-[8px]">
        <p class="font-medium">{{ get(commentInfo,'label') }}</p>
        <BaseElSwitch v-model="commentInfo.value" :inactive-text="`${displayText.activeText} ${get(commentInfo,'label')}`" />
      </header>
      <!-- 回覆截止時間提示 -->
      <header v-if="enableReply" class="flex items-center justify-between mb-[8px]">
        <p class="font-medium">{{ get(showReplyEndHint, 'label') }}</p>
        <BaseElSwitch v-model="showReplyEndHint.value" :inactive-text="displayText.activeText" />
      </header>
      <!-- 未回覆自動取消提示 -->
      <header v-if="enableNoReplyAutoCancel" class="flex items-center justify-between mb-[8px]">
        <div class="flex items-center gap-[8px]">
          <p class="font-medium">{{ get(showNoReplyAutoCancelHint, 'label') }}</p>
          <TipInfo :width="300" :size="16">
            {{ displayText.noReplyAutoCancelTooltip }}
          </TipInfo>
        </div>
        <BaseElSwitch v-model="showNoReplyAutoCancelHint.value" :inactive-text="displayText.activeText" />
      </header>
    </div>
  </GrayBlockContainer>
</template>

<script>
import { defineComponent, computed, watch, ref, reactive, onBeforeMount, set } from 'vue'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import ToggleGroup from '@/components/ToggleGroup.vue'
import TipInfo from '@/components/TipInfo.vue'
import { get, filter, map } from 'lodash'
import { appointmentInfoConfigTypes } from '@/config/progressNotification'
import { useVModel } from '@vueuse/core'
import { GetUserInfoSetting } from '@/api/org/org'
import { FindReservationParameter } from '@/api/reservation'
import store from '@/store'
import { checkUserFeature } from '@/store/modules/permission'

export default defineComponent({
  name: 'ReservationNotificationContentTemplate',
  components: { GrayBlockContainer, ToggleGroup, TipInfo },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:data'],
  setup (props, { emit }) {
    const syncData = useVModel(props, 'data', emit)
    const newData = reactive({

    })
    for (const key in appointmentInfoConfigTypes) {
      set(newData, key, {
        label: appointmentInfoConfigTypes[key],
        key,
        value: get(props, `data.${key}`),
      })
      // newData[key] = {
      //   label: appointmentInfoConfigTypes[key],
      //   key,
      //   value: get(props, `data.${key}`),
      // }
    }
    const contractPlan = computed(() => get(store.state.shop, 'shopConfig.ContractPlan'))
    // 是否顯示附加服務
    // const orderServiceAttachClientCheck = ref(false)
    // 單人多服務
    const allowOtherReservation = ref(false)
    // 多人單服務
    const allowOrderMorePeople = ref(false)
    // 是否啟用會員地址
    const enableUserAddress = ref(false)
    // 預約回覆設定狀態
    const enableReply = ref(false)
    const enableNoReplyAutoCancel = ref(false)
    const userPlanFeature = computed(() => get(store.getters, 'userPlanFeature'))
    const userFeatures = computed(() => get(store.getters, 'userFeatures'))
    const checkAction = (action) => {
      return checkUserFeature(userPlanFeature.value, userFeatures.value, action)
    }
    // 子項目
    const useSubService = computed(() => checkAction('admin.appointmentSubService.edit'))
    const useMemberAddress = computed(() => checkAction('adminView.member.findUserInfoMoreAddress'))
    const {
      showOrderCode,
      showMemberName,
      showAppointmentPeopleCount,
      showAppointmentStartDate,
      showUserAddress,
      showAppointmentOrderDepositStatus,
      showServiceName,
      showSubServiceName,
      showAppointmentStartTime,
      showAppointmentUnitName,
      showAppointmentResourceName,
      showAppointmentServiceAttach,
      showAppointmentUserComment,
      showUserName,
      showTotalPrice,
      showCustomFieldKeys,
      showAppointmentTotalBookingTime,
      showReplyEndHint,
      showNoReplyAutoCancelHint,
    } = newData

    const orderInfo = ref([
      showOrderCode,
      showMemberName,
      showAppointmentPeopleCount,
      showAppointmentStartDate,
      // showUserAddress,
      // showAppointmentOrderDepositStatus,
    ])
    const detailInfo = ref([
      showServiceName,
      // showSubServiceName,
      // showAppointmentStartTime,
      // showAppointmentUnitName,
      // showAppointmentResourceName,
      // showAppointmentServiceAttach,
    ])
    const otherInfo = ref([
      // showUserName,
      // { label: '其他服務', value: showServiceName.value, content: '比照詳細資訊的服務項目顯示狀態' },
      // { label: '子項目', value: showSubServiceName.value, content: '比照詳細資訊的子項目顯示狀態' },
      // { label: '預約時間', value: showAppointmentStartTime.value, content: '比照詳細資訊的預約時間顯示狀態' },
      // { label: '服務人員', value: showAppointmentUnitName.value, content: '比照詳細資訊的服務人員顯示狀態' },
      // { label: '服務設備', value: showAppointmentResourceName.value, content: '比照詳細資訊的服務設備顯示狀態' },
      // { label: '附加服務', value: showAppointmentServiceAttach.value, content: '比照詳細資訊的附加服務顯示狀態' },
    ])
    const appendItems = async () => {
      // orderInfo
      if (useMemberAddress.value && enableUserAddress.value) orderInfo.value.push(showUserAddress)
      if (get(contractPlan.value, 'useAppointmentDeposit')) orderInfo.value.push(showAppointmentOrderDepositStatus)
      // detailInfo
      if (useSubService.value) detailInfo.value.push(showSubServiceName)
      detailInfo.value.push(showTotalPrice)
      detailInfo.value.push(showAppointmentStartTime)
      detailInfo.value.push(showAppointmentTotalBookingTime)
      detailInfo.value.push(showAppointmentUnitName)
      if (get(contractPlan.value, 'useResource')) detailInfo.value.push(showAppointmentResourceName)
      detailInfo.value.push(showAppointmentServiceAttach)
      // otherInfo
      if (allowOrderMorePeople.value) otherInfo.value.push(showUserName)
      if (allowOtherReservation.value) {
        otherInfo.value.push({ label: '其他服務', value: showServiceName.value, content: '比照詳細資訊的服務項目顯示狀態' })
        if (useSubService.value) otherInfo.value.push({ label: '子項目', value: showSubServiceName.value, content: '比照詳細資訊的子項目顯示狀態' })
        otherInfo.value.push({ label: '預約時間', value: showAppointmentStartTime.value, content: '比照詳細資訊的預約時間顯示狀態' })
        otherInfo.value.push({ label: '預約時長', value: showAppointmentTotalBookingTime.value, content: '比照詳細資訊的預約時長顯示狀態' })
        otherInfo.value.push({ label: '服務人員', value: showAppointmentUnitName.value, content: '比照詳細資訊的服務人員顯示狀態' })
        if (get(contractPlan.value, 'useResource')) otherInfo.value.push({ label: '服務設備', value: showAppointmentResourceName.value, content: '比照詳細資訊的服務設備顯示狀態' })
        otherInfo.value.push({ label: '附加服務', value: showAppointmentServiceAttach.value, content: '比照詳細資訊的附加服務顯示狀態' })
      }
    }

    const commentInfo = ref(showAppointmentUserComment)

    watch(newData, (newVal) => {
      console.log('newData change')
      for (const obj in newVal) {
        set(syncData.value, newVal[obj].key, newVal[obj].value)
        // syncData.value[newVal[obj].key] = newVal[obj].value
      }
    }, { deep: true })

    const userInfoSettingFormData = ref([])
    const orgId = computed(() => get(store.getters, 'orgId'))
    const shopId = computed(() => get(store.getters, 'shop'))
    const displayText = computed(() => {
      const data = {
        orderInfo: {
          groupName: '訂單資訊',
          switchName: '訂單資訊',
        },
        detailInfo: {
          groupName: '詳細資訊',
          switchName: '詳細資訊',
        },
        otherInfo: {
          groupName: '其他服務 (客人端不顯示此標題)',
          switchName: '其他服務',
        },
        userInfoSettingFormData: {
          groupName: '其他會員資料 (自定義註冊欄位)',
          switchName: '其他會員資料',
        },
        activeText: '隱藏/顯示',
        noReplyAutoCancelTooltip: '請至「基本參數設定/預約模組參數設定/預約回覆設定」設定自動取消提示',
      }
      return data
    })

    // ?? 參照資料
    const showControl = computed(() => {
      const control = {
        otherInfo: allowOtherReservation.value || allowOrderMorePeople.value,
        userInfoSettingFormData: userInfoSettingFormData.value.length,
      }
      return control
    })

    const getUserInfoSetting = async () => {
      const [res, err] = await GetUserInfoSetting({
        orgId: orgId.value,
      })

      if (err) {
        if (err.status === 404) return
        return this.$message.error(err)
      }
      // 取得自定義欄位
      if (res && res.fields) {
        userInfoSettingFormData.value = map(filter(get(res, 'fields'), item => !item.isBase),
          item =>
            (
              {
                key: item.key,
                label: item.name,
                value: get(showCustomFieldKeys, 'value').includes(item.key), // 是否顯示
              }
            ),
        )
      }
    }
    const findReservationParameter = async () => {
      const res = await FindReservationParameter({ shopId: shopId.value })
      // orderServiceAttachClientCheck.value = get(res, 'orderServiceAttachClientCheck')
      allowOtherReservation.value = get(res, 'allowOtherReservation.value')
      allowOrderMorePeople.value = get(res, 'allowOrderMorePeople')
      enableUserAddress.value = get(res, 'enableUserAddress')
      // 取得回覆設定狀態
      enableReply.value = get(res, 'enableReply', false)
      enableNoReplyAutoCancel.value = get(res, 'enableNoReplyAutoCancel', false)
    }
    watch(userInfoSettingFormData, (newVal) => {
      syncData.value.showCustomFieldKeys = map(filter(newVal, item => item.value), item => item.key)
    }, { deep: true })

    onBeforeMount(async () => {
      await getUserInfoSetting()
      await findReservationParameter()
      await appendItems()
    })
    return {
      orderInfo,
      detailInfo,
      otherInfo,
      commentInfo,
      get,
      userInfoSettingFormData,
      allowOrderMorePeople,
      allowOtherReservation,
      newData,
      displayText,
      showControl,
      enableReply,
      enableNoReplyAutoCancel,
      showReplyEndHint,
      showNoReplyAutoCancelHint,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
